<template>
    <v-dialog v-model="dialog" :max-width="$vuetify.smAndDown ? undefined : '600'">
        <template v-slot:activator="{}">
            <v-tooltip bottom :max-width="$vuetify.smAndDown ? undefined : '300'">
                <template v-slot:activator="{on}">
                    <v-btn small color="secondary" depressed class="mr-12" v-on="on" :loading="cargandoPonderacion"
                           @click="abrir">
                        <v-icon small class="mr-2">mdi-cog</v-icon>
                        {{ $t("txt_btn") }}
                    </v-btn>
                </template>
                <span>{{ $t('ponderacion_descrip') }}</span>
            </v-tooltip>
        </template>

        <v-card>
            <v-card-title class="headline primary white--text">
                {{ $t("titulo") }}
            </v-card-title>

            <v-card-text class="mt-10">
                <v-row v-if="ponderaciones" no-gutters>
                    <v-col cols="12" v-for="ponderacion in ponderaciones" :key="ponderacion.codigo">
                        <v-slider
                            v-model="ponderacion.valor"
                            :min="ponderacion.min"
                            :max="ponderacion.max"
                            thumb-label="always"
                            :label="`${ponderacion.nombre} (${ponderacion.codigo})`"
                        />
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="10" class="body-1 font-weight-bold">
                        {{ $t("suma") }}
                    </v-col>
                    <v-col cols="2" class="body-1 text-right font-weight-bold" :class="{'error--text':sumaTotal > 100}">
                        {{ sumaTotal }} %
                    </v-col>
                    <v-col cols="12" class="font-italic body-2 text-right error--text">
                        <span v-show="sumaTotal !== 100">{{ $t("suma_error") }}</span>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider/>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text @click="cerrar">
                    {{ $t('cerrar') | capitalize }}
                </v-btn>
                <v-btn color="primary" text :disabled="sumaTotal  !== 100" :loading="guardandoPonderacion"
                       @click="guardar">
                    {{ $t('actualizar') | capitalize }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {HttpHelper} from "@/comunes/helpers/HttpHelper";

    export default {
        name: "DialogPrestacionComponente",
        props: {
            id: {type: Number, required: true}
        },
        data: () => ({
            dialog: false,
            cargandoPonderacion: false,
            guardandoPonderacion: false,
            ponderaciones: null
        }),
        computed: {
            sumaTotal() {
                if (this.ponderaciones == null) return 0;

                let suma = 0;
                this.ponderaciones.forEach((ponderacion) => {
                    suma += ponderacion.valor;
                });

                return suma;
            }
        },
        methods: {
            abrir() {
                this.cargarPonderacion().then(() => {
                    this.dialog = true;
                });
            },
            cerrar() {
                this.dialog = false;
                this.ponderaciones = null;
            },
            guardar() {
                this.guardandoPonderacion = true;
                HttpHelper.post(`proyecto/${this.id}/guardar-prestacionales-ponderacion`, this.ponderaciones)
                    .then(() => {
                        this.$emit("actualizado");
                        this.cerrar();
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        this.guardandoPonderacion = false;
                    });
            },
            cargarPonderacion() {
                this.cargandoPonderacion = true;
                let promise = HttpHelper.get(`proyecto/${this.id}/obtener-prestacionales-ponderacion`);
                promise
                    .then((ponderaciones) => {
                        this.ponderaciones = ponderaciones;
                    })
                    .catch(() => {
                    })
                    .finally(() => {
                        this.cargandoPonderacion = false;
                    });

                return promise;
            }
        }
    }
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
{
"es": {
"txt_btn":"Editar ponderación",
"titulo":"Ponderación indicadores prestacionales",
"suma":"Suma total",
"suma_error":"* la suma total no puede superar el 100%",
"ponderacion_descrip":"Haciendo clic podrás cambiar los coeficientes de ponderación entres los grupos de indicadores prestacionales."
}
}
</i18n>
<!--@formatter:on-->